const errors = [
    {
        code: 1001,
        title: "Error in updating order",
        message: "There was an error in updating your order. Please reach out to our support team with your email and this order number: "
    },
    {
        code: 1002,
        title: "Order already being processed",
        message: "This order is being processed. You should receive a confirmation email soon."
    },
    {
        code: 9999,
        title: "Unknown Error",
        message: "An unknown error has occurred. Please reach out to our support team with your email and this order number: "
    },
]

export default function getErrorTexts(code: number): { code: number, title: string, message: string } {
    const error = errors.find(error => error.code === code);
    // @ts-ignore
    if (!error) return errors.find(error => error.code === 9999);
    return error;
};
